module.exports = __webpack_public_path__ + "img/operationCapacity2.78c56383.png";